export default __webpack_public_path__ + "static/media/thumbnail2.9a2add35.jpg";